import { reactive } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

export interface ButtomItemData {
  icon?: string;
  round: boolean;
  color: string;
  spacer?: boolean;
  label?: string;
  router?: RouteLocationRaw;
  action?: Function;
  disabled?: boolean;
}

export interface ButtomData {
  show: boolean;
  items: ButtomItemData[];
}

export interface FooterData {
  color: string;
  show: boolean;
  buttons: ButtomData;
  default: {
    show: boolean;
  };
}

const defaultFooter: FooterData = {
  color: '#7DD420',
  show: false,
  default: {
    show: true
  },
  buttons: {
    show: false,
    items: []
  },
}

class FooterState {
  dataRender: FooterData = defaultFooter

  setFooter(data: FooterData) {
    this.dataRender = data
  }

  setFooterDefault() {
    this.dataRender = defaultFooter
  }
}

// Wrap in reactive() for Vue 3 reactivity
export const footerState = reactive(new FooterState()) as FooterState
